import Page from '@components/Page/Page';
import UnsubscribeGroup from '@components/SubscriptionGroups/UserUnsubscribe';
import { useLocale } from '@hooks/useLocale';
import React from 'react';

const UnsubscribePage: React.FC = () => {
    const { t } = useLocale();
    return (
        <Page
            title={t('subscription_group.unsubscribe_group')}
            className="bg-gray-50"
            withNavbar={false}
            withFullHeight
        >
            <UnsubscribeGroup />
        </Page>
    );
};

export default React.memo(UnsubscribePage);
